import { connect } from 'react-redux'
import MediaInfo from './MediaInfo.jsx'
import { getCurrentMediaInfo } from 'redux/mediaInfo/selectors'

const mapStateToProps = state => ({
    mediaInfo: getCurrentMediaInfo(state),
})

export const MediaInfoContainer = connect(
    mapStateToProps,
)(MediaInfo)
